import React from 'react';
import PropTypes from 'prop-types';
import clxBind from 'classnames/bind';
import styles from './styles.module.scss';

const clx = clxBind.bind(styles);

export default class Divider extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node,
  };

  static defaultProps = {
    title: null,
    className: undefined,
    children: null,
  };

  render() {
    const { title, className, children } = this.props;
    const dividerClasses = clx('divider', className);

    return <div className={dividerClasses}>{children || title}</div>;
  }
}
